import React, { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../config/api";
import { useAuth } from "../../context/AuthContext";
import { Container, Spinner, Alert, Badge } from "react-bootstrap";
import { Row, Col, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

// get the user id from the url
const UserDetails = () => {
  //get id from url and set userId to it
  const { id } = useParams();
  let userId = id;
  console.log("userId", id);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAuthHeaders } = useAuth();

  const handleBackNavigation = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
  };

  useEffect(() => {
    fetchUser();
  }, [userId]);

  const fetchUser = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(API_ENDPOINTS.users.getById(userId), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeaders(),
        },
      });
      if (!response.ok) throw new Error(`Error: ${response.status} - ${response.statusText}`);

      const data = await response.json();
      setUser(data.data || null);
      console.log("Individual user fetched successfully:", data);
    } catch (error) {
      console.error("Error fetching individual user:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="py-4 text-center">
        <Spinner animation="border" role="status" className="me-2" />
        <span>Loading user details...</span>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-4">
        <Alert variant="danger">
          <Alert.Heading>Unable to load user details</Alert.Heading>
          <p>{error}</p>
        </Alert>
      </Container>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const InfoItem = ({ label, value }) => (
    <div className="mb-4 pb-3 border-bottom">
      <div
        className="text-muted mb-1"
        style={{ fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.5px" }}
      >
        {label}
      </div>
      <div className="fw-semibold" style={{ fontSize: "1.1rem" }}>
        {value || "N/A"}
      </div>
    </div>
  );

  return (
    <div className="min-vh-100">
      <Container fluid className="py-5 px-4">
        <Row className="mb-5">
          <Col>
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <div className="d-flex align-items-center mb-3 mb-md-0">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center text-black fw-bold me-3"
                  style={{
                    width: "80px",
                    height: "80px",
                    fontSize: "2rem",
                    background: "rgba(255, 255, 255, 0.2)",
                    border: "3px solid rgba(0, 0, 0, 0.3)",
                  }}
                >
                  {user.firstName?.[0]}
                  {user.lastName?.[0]}
                </div>
                <div className="text-black">
                  <h1 className="mb-1 fw-bold">
                    {user.firstName} {user.lastName}
                  </h1>
                  <p className="mb-0 opacity-75" style={{ fontSize: "1.1rem" }}>
                    {user.email}
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Button variant="outline-secondary" size="sm" onClick={handleBackNavigation}>
                  Back
                </Button>
                <Badge
                  bg={user.isActive ? "success" : "secondary"}
                  className="px-4 py-2"
                  style={{ fontSize: "1rem" }}
                >
                  {user.isActive ? "Active" : "Inactive"}
                </Badge>
                <Badge bg="info" className="px-4 py-2" style={{ fontSize: "1rem" }}>
                  {user.role}
                </Badge>
              </div>
            </div>
          </Col>
        </Row>

        <div className="bg-white rounded-3 shadow p-4 p-md-5">
          <h3 className="mb-4 pb-2 border-bottom border-2 border-primary">User Information</h3>
          <Row>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="First Name" value={user.firstName} />
            </Col>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="Last Name" value={user.lastName} />
            </Col>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="Email" value={user.email} />
            </Col>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="Phone" value={user.phone} />
            </Col>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="Company" value={user.company} />
            </Col>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="License Number" value={user.licenseNumber} />
            </Col>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="Role" value={user.role} />
            </Col>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="Joined" value={formatDate(user.createdAt)} />
            </Col>
            <Col md={6} lg={4} className="mb-3">
              <InfoItem label="Last Login" value={formatDate(user.lastLogin)} />
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default UserDetails;
